export default __webpack_public_path__ + "static/media/img-c-00-bg-egt@2x.9fab34b3.jpg";